import { lxkCleanMarkdown } from './renderer';

export class SidebarManager {
    constructor(onSourceClick) {
        this.currentData = [];
        this.currentTitle = '';
        this.eventListeners = [];
        this.onSourceClick = onSourceClick;
    }

    cleanup() {
        this.eventListeners.forEach(({ element, type, handler }) => {
            element.removeEventListener(type, handler);
        });
        this.eventListeners = [];
    }

    registerEventListener(element, type, handler) {
        element.addEventListener(type, handler);
        this.eventListeners.push({ element, type, handler });
    }

    registerEventListener(element, type, handler) {
        element.addEventListener(type, handler);
        this.eventListeners.push({ element, type, handler });
    }

    truncateText(text, maxLength) {
        if (!text) return '';
        if (text.length <= maxLength) return text;
        return text.substring(0, maxLength).trim() + '...';
    }

    createSourceElement(source) {
        const sourceElement = document.createElement('div');
        sourceElement.className = 'lxk-mx-2 lxk-mb-1 lxk-p-2 hover: lxk-border lxk-border-lexeek-content-alt lxk-bg-lexeek-surface-alt lxk-rounded-lg hover:lxk-border-lexeek-accent lxk-transition-colors lxk-drop-shadow-md';
        sourceElement.setAttribute('data-redirect-url', source.redirect_url || '');
        
        sourceElement.innerHTML = `
            <h3 class="lxk-text-md lxk-font-medium lxk-text-lexeek-content lxk-truncate lxk-mx-1">${this.truncateText(source.title, 50) || 'Untitled'}</h3>
            ${source.content ? `<p class="lxk-text-sm lxk-text-lexeek-content-alt">${this.truncateText(lxkCleanMarkdown(source.content), 75)}</p>` : ''}
        `;

        this.registerEventListener(sourceElement, 'click', () => this.onSourceClick(source));

        return sourceElement;
    }

    lxkInjectToSideBar(data) {
        this.cleanup();
        this.currentData = data;

        const sidebarContent = document.createElement('div');
        sidebarContent.className = 'lxk-flex lxk-flex-col';

        // Add sources container
        const sourcesContainer = document.createElement('div');
        sourcesContainer.className = 'lxk-flex lxk-flex-col lxk-gap-1 lxk-p-1';

        // Add sources
        if (data && data.sources && data.sources.length > 0) {
            data.sources.forEach(source => {
                sourcesContainer.appendChild(this.createSourceElement(source));
            });
        } else {
            // Empty state
            const emptyState = document.createElement('div');
            emptyState.className = 'lxk-p-4 lxk-text-center lxk-text-lexeek-content-alt';
            emptyState.textContent = 'No sources available';
            sourcesContainer.appendChild(emptyState);
        }

        sidebarContent.appendChild(sourcesContainer);

        return sidebarContent.outerHTML;
    }
}
